import React from 'react'
import "./style.css"
const ErrorCon = ({color,texto}) => {
  return (
    <div className='loading text-center' style={{color:color}}>{texto}</div>
  )
}

export default ErrorCon;